import React, { useState } from 'react'
import { Outlet, useLocation } from 'react-router-dom';
import { useCustomerDetailsTabMenuUtils } from '../../../../../../utils/tabNavigationUtils/provider/useCustomerDetailsTabMenuUtils';
import { routes } from '../../../../../../constants';
import { baseRouteMaker, baseRouteMakerForSuperAdmin } from '../../../../../../constants/routeConsts';
import { Tabs } from '../../../../../common/tabs';
import { useSuperAdminCustomerDetailsTabMenuUtils } from '../../../../../../utils/tabNavigationUtils/super-admin/useSuperAdminCustomerDetailsTabMenuUtils';

const CustomerInfoDetails = () => {
  
  /* location dependencies */
  const location = useLocation();
  /* location dependencies */

  const customerDetailsMenuGroup = useSuperAdminCustomerDetailsTabMenuUtils();

  const renderTabs = () => {
    const pathname = location.pathname;
    if (pathname.includes(baseRouteMakerForSuperAdmin(routes.CUSTOMER_INFO_DETAILS))) {
      return customerDetailsMenuGroup;
    }
  };

  const listRoutesArray = new Array(
    ...customerDetailsMenuGroup
  )

  return (
    <>
    {
      listRoutesArray.some(
        (element) => element.url === location.pathname
      ) && <Tabs tabsMenuUtils={renderTabs()} />
    }
    </>
  )
}

export default CustomerInfoDetails